import type { EmptyArray } from '@mntn-dev/utility-types'

export const isEmptyArray = <T>(array: T[]): array is EmptyArray => {
  return array.length === 0
}

export function assertEmptyArray<T>(
  array: T[],
  message?: string
): asserts array is EmptyArray {
  if (!isEmptyArray(array)) {
    throw new Error(message ?? 'Expected empty array')
  }
}
